export default "__VITE_PUBLIC_ASSET__be33e3fa__"